"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ColorKeys", {
  enumerable: true,
  get: function () {
    return _colorTypes.ColorKeys;
  }
});
Object.defineProperty(exports, "Colors", {
  enumerable: true,
  get: function () {
    return _colors.Colors;
  }
});
Object.defineProperty(exports, "Gradients", {
  enumerable: true,
  get: function () {
    return _gradients.Gradients;
  }
});
Object.defineProperty(exports, "Palette", {
  enumerable: true,
  get: function () {
    return _palette.Palette;
  }
});
Object.defineProperty(exports, "Spacing", {
  enumerable: true,
  get: function () {
    return _spacing.Spacing;
  }
});
Object.defineProperty(exports, "Styles", {
  enumerable: true,
  get: function () {
    return _objectStyles.Styles;
  }
});
Object.defineProperty(exports, "Typography", {
  enumerable: true,
  get: function () {
    return _typography.Typography;
  }
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _colorTypes = require("./color-types");
var _colors = _interopRequireWildcard(require("./colors"));
var _gradients = _interopRequireWildcard(require("./gradients"));
var _objectStyles = _interopRequireWildcard(require("./object-styles"));
var _palette = _interopRequireWildcard(require("./palette"));
var _spacing = _interopRequireWildcard(require("./spacing"));
var _typography = _interopRequireWildcard(require("./typography"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
 * Do not edit directly
 */
const designTokens = {
  name: 'justfly',
  colors: _objectSpread(_objectSpread({}, _colors.default), {}, {
    palette: _palette.default
  }),
  gradients: _gradients.default,
  space: _spacing.default,
  styles: _objectStyles.default,
  typography: _typography.default
};
var _default = exports.default = designTokens;